import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { withDefaults } from "vue";
import { SearchbarProps } from "@/types";
import { useVModel } from "@/hooks";
import { Icon } from "@/components/common/display";


/**
 * Searchbar
 */
const __default__ = {
  name: "Searchbar",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {},
    hint: {},
    label: { default: "Search" }
  },
  emits: ["update:modelValue", "enter"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const model = useVModel(props, "modelValue");

/**
 * Emits an event when enter is clicked.
 */
function handleKeydown(e?: { key: string }) {
  if (e?.key === "Enter") {
    emit("enter");
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, {
    modelValue: _unref(model),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
    dense: "",
    outlined: "",
    clearable: "",
    label: props.label,
    hint: props.hint,
    class: "full-width",
    onKeydown: handleKeydown
  }, {
    append: _withCtx(() => [
      _renderSlot(_ctx.$slots, "append", {
        search: _unref(model) as string
      }),
      _createVNode(_unref(Icon), { variant: "search" })
    ]),
    _: 3
  }, 8, ["modelValue", "label", "hint"]))
}
}

})